export const TYPE_PC = Symbol("pc");
export const TYPE_SP = Symbol("sp");



// WEBPACK FOOTER //
// ./common/defines.jsx